import type { NexoyaUser } from '../types';

// True only for a loaded user who belongs to no active team. Returns false when the user is not
// loaded yet (null/undefined) so callers don't mistake the loading state for a team-less user.
export const hasNoActiveTeams = (user?: NexoyaUser | null): boolean => !!user && (user.teams?.length ?? 0) === 0;
